import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { GetHomePagelService } from "../../../APIs/Function/HomePageLinks/Services/GetService";
import HomePageTable from "../../../Components/Table/HomePageTable";
import { GetHomePagelinks } from "../../../APIs/Function/HomePageLinks/GetHomePagelinks";
import { Link } from "react-router-dom";
import Loader from "../../../Components/Loader/Loader";
import CustomButton from "../../../Components/Button/CustomButton";
const HomePageLinks = () => {
  const [pageLinksData, setPageLinks] = useState([]);
  const [serviceData, setServicesData] = useState([]);

  const handleServices = async () => {
    try {
      let res = await GetHomePagelService();
      setServicesData(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageLinks = async () => {
    try {
      let res = await GetHomePagelinks();
      setPageLinks(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlePageLinks();
    handleServices();
  }, []);

  return (
    <Box sx={{ width: "100%", p: "20px", boxSizing: "border-box" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {serviceData?.map((e, i) => (
          <Box
            sx={{
              border: "1px solid #DDDDDD",
              padding: { xs: "5px", md: "10px" },
              width: "18%",
              boxSizing: "border-box",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            <Link
              style={{ textDecoration: "none", color: "inherit" }}
              key={i}
              to={`/editservice/${e.id}`}
            >
              <Box sx={{ width: "50px", m: "auto", height: "50px" }}>
                <img
                  width={"100%"}
                  height={"100%"}
                  src={`https://api-qhealth.equitysofttechnologies.com//upload/images/${e.icon}`}
                  alt="preview"
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    fontSize: { xs: "13px", md: "14px" },
                    fontWeight: "600",
                    mt: "10px",
                    lineHeight: "20.4px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    maxWidth: "100%",
                    "&:hover": {
                      overflow: "visible",
                    },
                  }}
                >
                  {e.name}
                </Typography>
              </Box>
            </Link>
          </Box>
        ))}
      </Box>
      {/* table */}
      <Box>
        {pageLinksData?.length ? (
          <HomePageTable
            pageLinksData={pageLinksData}
            setPageLinksData={setPageLinks}
          />
        ) : (
          <Box
          sx={{
            display: "flex",
            mt: "25px",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <Link to={"/addpagelinks"}>
            <CustomButton
              sx={{
                width: "100%",
                bgcolor: "#31AEF4",
                "&:hover": {
                  bgcolor: "#31AEF4",
                },
              }}
            >
              ADD +
            </CustomButton>
          </Link>
        </Box>
        )}
      </Box>
    </Box>
  );
};

export default HomePageLinks;
